"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M9 2v1.083A6.002 6.002 0 018 15 6 6 0 017 3.083V2H6a1 1 0 110-2h4a1 1 0 010 2H9zM8 5a4 4 0 104 4H8V5z"];
//# sourceMappingURL=stopwatch.js.map